<template>
    <li
        class="ds-menu-group"
        role="none"
    >
        <div
            v-if="label"
            class="ds-menu-group-label px-3 py-1 text-left"
        >
            <p class="text-content-md font-semibold text-content-primary">
                {{ label }}
            </p>
        </div>
        <ul role="group">
            <slot />
        </ul>
    </li>
</template>

<script setup lang="ts">
import type { DsMenuGroupProps } from './menu.types';

defineProps<DsMenuGroupProps>();
</script>

<style scoped lang="scss">
.ds-menu-group {
    &:not(:last-child) {
        @apply border-b border-ds-primary-200;
    }
}
</style>
